// ISO-639-1 codes
const locales = ["de", "en"];

module.exports = {
  locales,
};
